// Virtual Assistant Configuration Types

export enum InteractionType {
  None = "none",
  Click = "click",
  Focus = "focus",
  PointAndClick = "pointAndClick",
}

export enum OnVideoCompleteAction {
  PlayDingSound = "PlayDingSound",
}

export interface AssistanceVideo {
  order: number;
  awaitedInteractionToStart: InteractionType;
  awaitedInteractionAtComplete: InteractionType;
  videoName: string;
  onCompleteInteractionSuccess?: AssistanceVideo | null;
  onCompleteInteractionFail?: AssistanceVideo | null;
  timeOutInSeconds: number;
  errorVideoLoopCount?: number;
  onCompleteAction?: OnVideoCompleteAction;
  shouldAppearOnce?: boolean;
}
